<template>
	<div class="position-relative">
		<transition name="vue-table-loader">
			<div class="vue-table-loader" v-if="loading">
				<span class="fa fa-cog fa-spin fa-3x"></span>
			</div>
		</transition>
		<div class="row">
			<div class="col-md-4">
				<base-filter-bar placeholder="Search Users"></base-filter-bar>
			</div>
			<div class="col-md-8">
				<base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
			</div>
		</div>
		<div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
			<vuetable ref="vuetable"
				:api-url="grid"
				:fields="fields"
				:css="css.table"
				:per-page="perPage"
				:append-params="moreParams"
				noDataTemplate="No Users Found"
				pagination-path=""
				@vuetable:pagination-data="onPaginationData"
				@vuetable:loaded="onLoaded"
			>
				<template slot="actions" slot-scope="props">
					<a class="btn btn-outline-primary" :href="'/users/' + props.rowData.id + '/edit/'">
						View
					</a>
				</template>
				<template slot="roles" slot-scope="props">
					<div>
						<a class="badge badge-primary"
							v-for="role in props.rowData.roles"	
							:href="'/roles/' + role.id + '/edit/'"
							:key="role.id"
						>
							{{role.display_name}}
						</a>
					</div>
				</template>
				<template slot="fullname" slot-scope="props">
					{{props.rowData.firstname}} {{props.rowData.lastname}}
				</template>
				<template slot="apikey" slot-scope="props">
					<div class="badge-container">
						<div v-if="props.rowData.oauth_access_token != undefined" class="badge badge-default">
							Active
						</div>
						<div v-else class="badge badge-default">Inactive</div>
					</div>
				</template>
			</vuetable>
			<div class="row">
				<div class="col-md-6">
					<base-pagination-info :css="css.table" ref="paginationInfo"></base-pagination-info>
				</div>
				<div class="col-md-6">
					<base-pagination  ref="pagination"
						@vuetable-pagination:change-page="onChangePage"
					></base-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	var base_url = window.location.protocol + "//" + window.location.host

	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import moment from 'moment';
	import BaseFilterBar from './base-filter-bar.vue';
	import BasePagination from './base-pagination.vue';
	import BasePaginationInfo from './base-pagination-info.vue';
	import BaseSelectVisible from './base-select-visible.vue';

	Vue.use(VueEvents)

	export default {
		name: 'users-listing',
		props: [],
		components:{
			'base-filter-bar': BaseFilterBar,
			'base-pagination': BasePagination,
			'base-pagination-info': BasePaginationInfo,
			'base-select-visible': BaseSelectVisible,
		},
		data() {
			return {
				perPage: 10,
				moreParams: {},
				loading: true,
				fields: [
					{
						name: '__slot:fullname',
						sortField: 'firstname',
						title: 'Full Name',
					},
					{
						name: 'email',
						title: 'Email Address',
						callback: 'linkEmail'
					},
					{
						name: '__slot:roles',
						title: 'Roles',
					},
					{
						name: 'confirmed',
						title: 'Confirmed',
						callback: 'confirmed',
					},
					{
						name: '__slot:apikey',
						title: 'API Key',
						titleClass: 'actions-single-column',
					},
					{
						name: '__slot:actions',
						titleClass: 'actions-single-column',
					},
				],
				amountsShown: [
					{ text: '10', value: 10 },
					{ text: '25', value: 25 },
					{ text: '50', value: 50 },
					{ text: '100', value: 100 }
				],
				grid: base_url + "/users/grid",
				css: {
					table: {
						tableClass: 'table table-striped table-bordered table-middle',
						ascendingIcon: 'sort-icon-asc',
						descendingIcon: 'sort-icon-desc',
						infoClass: '',
					},
				},
			}
		},
		mounted() {
			this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
			this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
			this.$events.$on('filter-reset', e => this.onFilterReset())
		},
		watch: {
			'perPage' (val, oldVal) {
				this.$nextTick(function() {
					this.$refs.vuetable.refresh()
				})
			},
		},
		methods: {
			overrideBadge (value) {
				return value == '0' ? 
					'<div class="badge badge-success">Yes</div>' : 
					'<div class="badge badge-danger">No</div>'
			},
			confirmed (value) {
				return value == '0' ? 
					'<div class="badge badge-warning w-100">Pending</div>' : 
					'<div class="badge badge-success w-100">Confirmed</div>'
			},
			linkEmail (value) {
				return '<a href="mailto:' + value + '">' + value + '</a>'
			},
			formatDate (value) {
				if (value === null) {
					return 'Never';
				}
				return moment(value).format("MMM Do YY");
			},
			onPaginationData (paginationData) {
				this.$refs.pagination.setPaginationData(paginationData)
				this.$refs.paginationInfo.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.vuetable.changePage(page)
			},
			editRow(rowData){
				console.log(rowData);
			},
			doVisibleSet (perPageValue) {
				this.perPage = perPageValue;
				Vue.nextTick( () => this.$refs.vuetable.refresh())
			},
			onFilterSet (filterText) {
				this.moreParams = {
					'filter': filterText
				};

				Vue.nextTick( () => this.$refs.vuetable.refresh())
			},
			onFilterReset () {
				this.moreParams = {};

				Vue.nextTick( () => this.$refs.vuetable.refresh())
			},
			onLoaded: function () {
				this.loading = false;
			}
		}
	};
</script>